module.exports = __webpack_public_path__ + "img/file-xlsx.8b5f6ab9.svg";